import { NextPage, NextPageContext } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { NewsPage } from 'containers/news';
import { newsBg } from 'images/news';
import services from 'services';
import { NewsPostList, PostCollection } from 'services/news/types';
import { withENV } from 'config/env';

interface NewsProps {
  posts: NewsPostList[];
  total: number;
  page: number;
}

const News: NextPage<NewsProps> = (props) => {
  const { posts, total, page } = props;

  return (
    <>
      <Header
        title="News"
        description="Stay updated with the latest developments and insights from Utilities One"
        image={newsBg}
      />
      <NewsPage listNews={posts} total={total} selectedPage={page} />
    </>
  );
};

export const getServerSideProps = async (ctx: NextPageContext): Promise<unknown> => {
  const page = Number(ctx.query.page || 1);
  const { newsService } = services;
  let response: PostCollection = { data: [], total: 0 };
  try {
    response = await newsService.getAllPosts(page, '');
  } catch (e) {
    console.log(e);
  }
  return {
    props: withENV({
      posts: response.data,
      total: response.total,
      page: page,
    }),
  };
};

export default News;
